module.exports = __webpack_public_path__ + "assets/img/img_exchange.0a1ca843.svg";